module.exports = __webpack_public_path__ + "static/resources_04-560x320-a37def386efe9aae0d34083064e7e397.jpg";